// AuthContext.js
import React, { createContext, useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";

import { auth } from "./firebase-config";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      (currentUser) => {
        if (currentUser) {
          setupTokenRefresh(currentUser);
          const userData = {
            name: currentUser.displayName,
            email: currentUser.email,
          };
          setUser(userData);
          localStorage.setItem("user", JSON.stringify(userData)); // Save to local storage
        } else {
          setUser(null);
          localStorage.removeItem("user"); // Clear local storage on logout
        }
      },
      (error) => {
        console.error("Error in onAuthStateChanged:", error);
      }
    );

    return () => unsubscribe();
  }, []);

  const setupTokenRefresh = (user) => {
    const refreshToken = async () => {
      try {
        // localStorage.removeItem('accessToken');
        const newToken = await user.getIdToken(true); // Force refresh the token
        localStorage.setItem("accessToken", newToken); // Store the new token
      } catch (error) {
        console.error("Error refreshing token:", error);
      }
    };

    // Refresh the token every 1 hour (3600000 milliseconds)
    // const intervalId = setInterval(refreshToken, 10 * 1000);
    const interval = 30 * 60 * 1000;
    setInterval(() => {
      refreshToken();
    }, interval);
  };

  return (
    <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
  );
};
